import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchCashflowShortfall,
  fetchSafeToSpend,
  fetchUpcomingBills,
  fetchUserDetail,
  searchUsersByEmail,
} from "../../services/SupportDebugService";

// Error envelopes are shaped { "msg": "..." }; surface that message to the UI.
const toErrorMessage = (error: unknown): string => {
  const err = error as { response?: { data?: { msg?: string } }; message?: string };
  return err.response?.data?.msg || err.message || "An unexpected error occurred";
};

export const searchSupportDebugUsersAsync = createAsyncThunk(
  "supportDebug/searchUsers",
  async (email: string, { rejectWithValue }) => {
    try {
      return await searchUsersByEmail(email);
    } catch (error: unknown) {
      return rejectWithValue(toErrorMessage(error));
    }
  }
);

export const fetchSupportDebugUserAsync = createAsyncThunk(
  "supportDebug/fetchUser",
  async (userId: string, { rejectWithValue }) => {
    try {
      return await fetchUserDetail(userId);
    } catch (error: unknown) {
      return rejectWithValue(toErrorMessage(error));
    }
  }
);

export const fetchSupportDebugUpcomingBillsAsync = createAsyncThunk(
  "supportDebug/fetchUpcomingBills",
  async ({ userId, days }: { userId: string; days?: number }, { rejectWithValue }) => {
    try {
      return await fetchUpcomingBills(userId, days);
    } catch (error: unknown) {
      return rejectWithValue(toErrorMessage(error));
    }
  }
);

// Object arg (not a bare string) so reducers can guard on meta.arg.userId,
// matching the other tool thunks.
export const fetchSupportDebugSafeToSpendAsync = createAsyncThunk(
  "supportDebug/fetchSafeToSpend",
  async ({ userId }: { userId: string }, { rejectWithValue }) => {
    try {
      return await fetchSafeToSpend(userId);
    } catch (error: unknown) {
      return rejectWithValue(toErrorMessage(error));
    }
  }
);

export const fetchSupportDebugCashflowAsync = createAsyncThunk(
  "supportDebug/fetchCashflowShortfall",
  async (
    { userId, asOfDate }: { userId: string; asOfDate?: string },
    { rejectWithValue }
  ) => {
    try {
      return await fetchCashflowShortfall(userId, asOfDate);
    } catch (error: unknown) {
      return rejectWithValue(toErrorMessage(error));
    }
  }
);
